import { Country } from './country';
import { OrganizationType } from './organization-type';

export interface Organization {
  organizationId: number;
  mpnId: string;
  nominationId: number;
  companyName: string;
  address1: string;
  address2: string;
  city: string;
  stateProvince: string;
  postalCode: string;
  country: Country;
  phoneNumber: string;
  websiteUrl: string;
  regionalCeoFullName?: string;
  regionalCeoEmail?: string;
  prefix: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  organizationTypeId: OrganizationType;
}

export function createOrganizationDraft(organizationTypeId: OrganizationType): Organization {
  return {
    organizationId: 0,
    nominationId: 0,
    mpnId: '',
    companyName: '',
    address1: '',
    address2: '',
    city: '',
    stateProvince: '',
    postalCode: '',
    country: {
      countryId: 0,
      countryCode: '',
      displayName: '',
      postalCodeRequired: false
    },
    phoneNumber: '',
    websiteUrl: '',
    prefix: '',
    firstName: '',
    lastName: '',
    emailAddress: '',
    organizationTypeId: organizationTypeId,
  };
}
